import React, { useEffect, useState } from "react";
import API from "../services/api";

const AssignedVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchVendors();
  }, [date]);

  const fetchVendors = async () => {
    setLoading(true);
    setError("");
    try {
      let url = "/employee/vendors";
      if (date) {
        url += `?date=${date}`;
      }
      const res = await API.get(url);
      setVendors(res.data);
    } catch (err) {
      console.error("Error fetching vendors:", err);
      setError("Failed to load vendors. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">📦 Assigned Vendors</h2>

      {/* Date Filter */}
      <div className="mb-4 flex gap-2">
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="border px-3 py-2 rounded"
        />
        <button
          onClick={() => setDate(new Date().toISOString().split("T")[0])}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Today
        </button>
        <button
          onClick={() => setDate("")}
          className="bg-gray-500 text-white px-4 py-2 rounded"
        >
          Clear
        </button>
      </div>

      {/* Loading */}
      {loading && <p className="text-gray-600">Loading vendors...</p>}

      {/* Error */}
      {error && <p className="text-red-500">{error}</p>}

      {/* Vendor List */}
      {!loading && !error && vendors.length > 0 ? (
        <table className="w-full border-collapse border border-gray-300 bg-white shadow-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-4 py-2 text-left">#</th>
              <th className="border px-4 py-2 text-left">Name</th>
              <th className="border px-4 py-2 text-left">Email</th>
              <th className="border px-4 py-2 text-left">Phone</th>
              <th className="border px-4 py-2 text-left">Assigned Date</th>
            </tr>
          </thead>
          <tbody>
            {vendors.map((vendor, index) => (
              <tr key={vendor._id}>
                <td className="border px-4 py-2">{index + 1}</td>
                <td className="border px-4 py-2 font-semibold">{vendor.name}</td>
                <td className="border px-4 py-2">{vendor.email}</td>
                <td className="border px-4 py-2">{vendor.phone}</td>
                <td className="border px-4 py-2">
                  {new Date(vendor.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        !loading && !error && <p>No vendors found for this date.</p>
      )}
    </div>
  );
};

export default AssignedVendors;
